import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ConsultationInquiry from "./sections/ConsultationInquiry";
import AbuDhabiHeadquarters from "./sections/AbuDhabiHeadquarters";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ConsultationInquiry />
      <AbuDhabiHeadquarters />
      <Footer />
    </div>;
}